<template>
  <main class="app-content">
    <div class="app-title">
      <div>
        <h1>
          <font-awesome-icon icon="link"/>
          Webhook Vietguys
        </h1>
      </div>
    </div>
    <webhook-vietguys-list></webhook-vietguys-list>
  </main>
</template>

<script>
import WebhookVietguysList from "@/views/webhook-vietguys/WebhookVietguysList.vue";

export default {
  components: {WebhookVietguysList},
  data() {
    return {}
  }
}
</script>